export function initialState () {
  return {
    // Currently logged in user
    currentUser: {},
    refreshTokenExpiresAtWarnLimit: 0,
    refreshTokenExpiresAt: 1000 * 60 * 4, // 240_000 Milliseconds / 4 minutes,
    notifications: [],
    status: '',
    token: '',
    siteSettings: [],
    alert: {
      message: '',
      type: '',
      errorObject: null,
      isShowing: false,
    },
    settings: {
      metadata: {
        checklists: {},
        docketEntryTypes: {},
        documentSets: {},
        ethnicities: {},
        languages: {},
        legalCaseTypes: {},
        locations: {},
        preferenceCategories: {},
        partyRoles: {},
        tasks: {},
        teams: {},
      },
      retrieved: {
        docketEntryTypes: false,
        documentSets: false,
        checklists: false,
        ethnicities: false,
        languages: false,
        legalCaseTypes: false,
        locations: false,
        preferenceCategories: false,
        partyRoles: false,
        tasks: false,
        teams: false,
        siteSettings: false,
      },
    },
    models: {
      checklists: [],
      countries: [],
      currentParty: null,
      currentRecordParties: [],
      currentUserAllDocketEntries: [],
      currentDocketEntries: [],
      docketEntryTypes: [],
      documentSets: [],
      ethnicities: [],
      editedParty: null,
      genders: [],
      languages: [],
      legalCaseTypes: [],
      locations: [],
      preferenceCategories: [],
      partyRoles: [],
      tasks: [],
      teams: [],
      users: [],
      userTypeOptions: [],
      filteredDocketEntryTypes: [],
    },
    dialogOpenStates: {
      createCase: false,
      editCase: false,
      createRecord: false,
      editRecord: false,
      editUser: false,
      openEntriesMassAssignmentDialog: false,
      dataTypes: {
        checklists: false,
        docketEntryTypes: false,
        documentSets: false,
        ethnicities: false,
        languages: false,
        legalCaseTypes: false,
        locations: false,
        preferenceCategories: false,
        partyRoles: false,
        tasks: false,
        teams: false,
      },
      message: false,
      viewAdverseIndividuals: false,
    },
    dashboard: {
      eventsUsers: [],
      tasksUsers: [],
      eventsDates: {},
      tasksDates: {},
    },
    partyUpdate: {
      characteristicAlert: false,
      updatedDbNames: [],
    },
    recordSearchData: { term: null, forRecord: null },
    reportsData: {
      currentType: '',
      legalCases: [],
      partiesByCase: [],
      userAccounts: [],
      priorityDate: [],
      untrackedCases: [],
    },
    tasksData: {
      assignees: [],
    },
    gcalIdPrefix: 'docketentr',
  }
}
